/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import EnvelopeWithBox from '../components/EnvelopeWithBox';
import AddEditPayee from '../components/AddEditPayee';

const AddEditPayeePage: React.FC = () => {
  return (
    <EnvelopeWithBox blockName='Add/Edit Payee'>
      <AddEditPayee />
    </EnvelopeWithBox>
  );
};

export default AddEditPayeePage;
